<template>
  <v-container>
    <v-row v-if="notification && notification.formatted">
      <v-col cols="4" class="pt-0">
        <v-row>
          <v-col class="text-h5">
            Tripwires
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              :value="notification.formatted.name"
              label="Notification Name"
              :error-messages="errorMessageName"
              class="pt-0"
              :maxlength="75"
              :disabled="readOnly"
              @input="handleChangeName"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-radio-group
              :value="notification.formatted.docType"
              label="Tripwire types"
              class="mt-0 pt-0"
              :disabled="readOnly"
              @change="handleChangeTripwireType"
            >
              <v-radio
                v-for="item in tripwireTypes"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="1"></v-col>
      <v-col>
        <span class="text-h6">{{ tripwireTypeTitle }}</span>

        <NotificationsTripwiresRisk
          v-if="notification.formatted.docType === typeRiskRating"
          :read-only="readOnly"
        ></NotificationsTripwiresRisk>
        <NotificationsTripwiresEvacuation
          v-if="notification.formatted.docType === typeEvacuation"
          :read-only="readOnly"
        >
        </NotificationsTripwiresEvacuation>
        <NotificationsTripwiresHotspot
          v-if="notification.formatted.docType === typeHotspot"
          :read-only="readOnly"
        >
        </NotificationsTripwiresHotspot>
        <NotificationsTripwiresPulse
          v-if="!hasEssentials && notification.formatted.docType === typePulse"
          :read-only="readOnly"
        >
        </NotificationsTripwiresPulse>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lodashGet from "lodash/get";
import lodashFind from "lodash/find";
import lodashCloneDeep from "lodash/cloneDeep";
import lodashRemove from "lodash/remove";

import { MODULE_PREFIX_NOTIFICATIONS } from "@/store";
import { GET_NOTIFICATION } from "@/store/actions.type";
import { mapGetters } from "vuex";
import {
  NOTIFICATION_TRIPWIRE_TYPES,
  NOTIFICATION_TRIPWIRE_TYPE_RISK_RATING,
  NOTIFICATION_TRIPWIRE_TYPE_EVACUATION,
  NOTIFICATION_TRIPWIRE_TYPE_HOTSPOT,
  NOTIFICATION_TRIPWIRE_TYPE_PULSE,
} from "@/common/constants/notifications";
import { hasEssentialsAccess } from "@/services/user/user.service";

export default {
  name: "NotificationsStepTripwires",
  components: {
    NotificationsTripwiresRisk: () =>
      import("@/components/notifications/NotificationsTripwiresRisk"),
    NotificationsTripwiresEvacuation: () =>
      import("@/components/notifications/NotificationsTripwiresEvacuation"),
    NotificationsTripwiresHotspot: () =>
      import("@/components/notifications/NotificationsTripwiresHotspot"),
    NotificationsTripwiresPulse: () =>
      import("@/components/notifications/NotificationsTripwiresPulse"),
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const hasEssentials = hasEssentialsAccess();
    let tripwireTypes = lodashCloneDeep(NOTIFICATION_TRIPWIRE_TYPES);
    if (hasEssentials) {
      tripwireTypes = lodashRemove(tripwireTypes, (t) => {
        return t.value !== NOTIFICATION_TRIPWIRE_TYPE_PULSE;
      });
    }
    return {
      hasEssentials: hasEssentials,
      tripwireTypes: tripwireTypes,
      errorMessageName: null,
      typeRiskRating: NOTIFICATION_TRIPWIRE_TYPE_RISK_RATING,
      typeEvacuation: NOTIFICATION_TRIPWIRE_TYPE_EVACUATION,
      typeHotspot: NOTIFICATION_TRIPWIRE_TYPE_HOTSPOT,
      typePulse: NOTIFICATION_TRIPWIRE_TYPE_PULSE,
    };
  },
  computed: {
    ...mapGetters({
      notification: MODULE_PREFIX_NOTIFICATIONS + "notification",
    }),
    tripwireTypeTitle() {
      if (lodashGet(this.notification, "formatted.docType")) {
        const tripwireType = lodashFind(this.tripwireTypes, [
          "value",
          this.notification.formatted.docType,
        ]);
        if (tripwireType && tripwireType.text) {
          return tripwireType.text;
        }
      }
      return null;
    },
  },
  mounted() {},
  methods: {
    handleChangeName(value) {
      const notification = lodashCloneDeep(this.notification);
      notification.formatted = notification.formatted || {};
      notification.formatted.name = value;
      this.update(notification);
    },
    handleChangeTripwireType(value) {
      const notification = lodashCloneDeep(this.notification);
      notification.formatted = notification.formatted || {};
      notification.formatted.docType = value;
      if (lodashGet(notification, "formatted.params.locations")) {
        delete notification.formatted.params.locations;
      }
      if (lodashGet(notification, "formatted.params.hotspotTypes")) {
        delete notification.formatted.params.hotspotTypes;
      }
      if (lodashGet(notification, "formatted.params.pulseTrigger")) {
        delete notification.formatted.params.pulseTrigger;
      }
      if (lodashGet(notification, "formatted.params.pulseScoreDrop")) {
        delete notification.formatted.params.pulseScoreDrop;
      }
      if (lodashGet(notification, "formatted.params.riskTypes")) {
        delete notification.formatted.params.riskTypes;
      }
      this.update(notification);
    },
    update(notification) {
      this.$store.dispatch(
        MODULE_PREFIX_NOTIFICATIONS + GET_NOTIFICATION,
        notification
      );
    },
  },
  watch: {},
};
</script>

<style>
.hyp-types .v-btn-toggle {
  display: flex !important;
  flex-direction: column !important;
}
</style>
<style scoped></style>
